import { useEffect, useState } from "react"
import { FirstScreen } from "components/ui/FirstScreen/FirstScreen"
import { H1 } from "components/ui/typography/titles/Titles"
import { Form, Input } from "antd"
import { ButtonPrimary } from "components/ui/buttons/ButtonPrimary/ButtonPrimary"
import { CustomNavLink } from "components/ui/CustomNavLink/CustomNavLink"
import { AuthProvider } from "components/providers/Forms.provider"
import { useResetPassword } from "hooks/api/resetPassword/resetPassword.hook"
import { useMessage } from "hooks/message.hook"
import { EmailSent } from "./layout/EmailSent/EmailSent"
import style from "./PageForgotPassword.module.scss"

const { pageForgotPassword, topBlock, text, formWrapper, input } = style

export const PageForgotPassword = () => {
	const { mutate: resetPasswordMutation } = useResetPassword()
	const { error: errorMessage } = useMessage()
	const [emailSent, setEmailSent] = useState(false)

	const [form] = Form.useForm()
	const values = Form.useWatch([], form)
	const [submittable, setSubmittable] = useState(false)

	// Validate form fields to determine if the button should be submittable
	useEffect(() => {
		form.validateFields({ validateOnly: true }).then(
			() => {
				setSubmittable(true)
			},
			() => {
				setSubmittable(false)
			},
		)
	}, [values, form])

	// Handle form submission
	const submitFormHandle = () => {
		resetPasswordMutation(values.email, {
			onSuccess: () => {
				form.resetFields()
				setEmailSent(true)
			},
			onError: (e) => {
				errorMessage(e.message || "Something went wrong, please try again later")
			},
		})
	}

	return (
		<FirstScreen>
			{emailSent ? (
				<EmailSent email={values?.email} />
			) : (
				<div className={pageForgotPassword}>
					<div className={topBlock}>
						<H1>Forgot password</H1>
						<p className={text}>Enter your email address below and we’ll send you password reset instructions.</p>
					</div>
					<div className={formWrapper}>
						<AuthProvider>
							<Form form={form} onFinish={submitFormHandle}>
								<Form.Item className={input} name="email" rules={[{ required: true, type: "email" }]}>
									<Input placeholder="Email" size="large" />
								</Form.Item>
								<ButtonPrimary submittable={submittable}>Send me reset instructions</ButtonPrimary>
							</Form>
						</AuthProvider>
					</div>
					<CustomNavLink to="/">Wait, I remember my password</CustomNavLink>
				</div>
			)}
		</FirstScreen>
	)
}
